import { BrowserRouter, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import EventPage from "./pages/EventPage";
import Landing from "./pages/Landing";
import Events from "./pages/Events";
import Scoreboard from "./pages/Scoreboard";
import Footer from "./components/Footer";
import AdminPanel from "./pages/AdminPanel";
import Login from "./pages/Login";
import ScrollToTop from "./components/ScrollToTop";
import {useAuthState} from 'react-firebase-hooks/auth';
import { auth } from './firebase/config';
import ReactGA from 'react-ga';
import { useEffect } from "react";

function App() {

	const [user] = useAuthState(auth);

	useEffect(() => {
		ReactGA.pageview(window.location.pathname + window.location.search);
	}, []);

	return (
		<BrowserRouter>
			<div className="bg-[#060606] text-slate-100 font-hanoble overflow-hidden scroll-smooth">
				<Navbar />
				<ScrollToTop />
				<Routes>
					<Route path="/" element={<Landing />} />
					<Route path="/events" element={<Events />} />
					<Route path="/scoreboard" element={<Scoreboard />} />
					<Route path="/:key" element={<EventPage />} />
					{user ? <Route path="/adminpanel" element={<AdminPanel />} /> : <Route path="/adminpanel" element={<Login />} />}
				</Routes>
				<Footer />
			</div>
		</BrowserRouter>
	);
}

export default App;